<div
  ngbDropdown
  display="dynamic"
  placement="bottom-right"
  #myDrop="ngbDropdown"
  routerLink="/checkout"
  (mouseenter)="$event.stopPropagation(); myDrop.open()"
  (mouseleave)="$event.stopPropagation(); myDrop.close()"
>
  <div class="d-block">
    <button class="btn cart-button" role="button" id="cartIcon" ngbDropdownAnchor>
      <i [ngClass]="cartContents ? 'fas fa-shopping-cart' : 'fa fa-spinner fa-pulse fa-fw'"></i>
      <span *ngIf="!!cartContents" class="badge">{{ cartContents.rows.length }}</span>
    </button>
    <div ngbDropdownMenu aria-labelledby="cartIcon">
      <div class="cart-content container" *ngIf="!!cartContents">
        <div class="row pl-4">
          <div *ngIf="!isReturNoPrice" class="col-12 text-right">
            <h5>
              {{ cartContents.totalValue | gungCurrency: cartContents.currency }}
            </h5>
          </div>
          <div class="col-12 pb-1">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary w-100"
              (click)="$event.preventDefault(); $event.stopPropagation(); clearCart()"
              translate
            >
              CLEAR_CART
            </button>
          </div>
          <div class="col-12 pb-1">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary w-100"
              (click)="$event.preventDefault(); $event.stopPropagation(); saveCart()"
              translate
            >
              SAVE_CART
            </button>
          </div>
          <div class="col-12 pb-1">
            <button
              type="button"
              class="btn btn-sm btn-primary w-100 navbarcart-btn-checkout"
              routerLink="/checkout"
              (click)="$event.preventDefault(); $event.stopPropagation()"
              translate
            >
              CHECKOUT
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
